import { COLUMN_FIXED_ADDRESS, COLUMN_IP_ADDRESS, COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE, COLUMN_CONTROLLER } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const IOModuleColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        sortByName: "devName",
        sortDirection: "asc",
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        sortByName: "devFixedAddr",
        sortDirection: "asc",
        id: 1,
        active: true,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        sortByName: "devIpAddress",
        sortDirection: "asc",
        id: 2,
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 4,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    },
    {
        heading: "Controller",
        accessor: "controller",
        isNumeric: false,
        id: 5,
        sortByName: "controller.devName",
        sortDirection: "asc",
        active: true,
        searchOnName: "terminal.controller.deviceImprox.id",
        lookupName: "terminal.controller.deviceImprox.devName",
        translationKey: "controller",
        columnId: COLUMN_CONTROLLER,
    },
    {
        heading: "Preset",
        accessor: "preset",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "preset"
    },
    {
        heading: "Lift",
        accessor: "liftName",
        isNumeric: false,
        id: 7,
        active: false,
        translationKey: "lift",
        // columnId: COLUMN_LIFT
    },
];

export default IOModuleColumns
